import apiClient from './client';

// ------------------------------------------------------------------
// 五维配置 —— LLM 配置（LLMConfig）
//   GET    /api/v1/playground/llm-configs   ← listLlmConfigs（练玉坊：只返回当前用户自建配置）
//   其余写操作复用主平台端点 /api/v1/llm-configs（加密存储 key）
// ------------------------------------------------------------------

export interface LlmConfig {
  id: string;
  name: string;
  provider?: string;
  model?: string;
  base_url?: string;
  api_key?: string;
  temperature?: number;
  max_tokens?: number;
  is_global?: boolean;
  is_vision_default?: boolean;
  enabled?: boolean;
  [key: string]: unknown;
}

export interface CreateLlmConfigInput {
  name: string;
  provider?: string;
  model?: string;
  base_url?: string;
  api_key?: string;
  temperature?: number;
  max_tokens?: number;
  is_global?: boolean;
  is_vision_default?: boolean;
  enabled?: boolean;
}

/** 列出当前用户自建的 LLM 配置（练玉坊专属端点，不含平台/全局 mock 配置，不回显 key） */
export async function listLlmConfigs(): Promise<LlmConfig[]> {
  const res = await apiClient.get<LlmConfig[]>('/playground/llm-configs');
  return res.data;
}

export async function createLlmConfig(input: CreateLlmConfigInput): Promise<LlmConfig> {
  const res = await apiClient.post<LlmConfig>('/llm-configs', input);
  return res.data;
}

export async function getLlmConfig(configId: string): Promise<LlmConfig> {
  const res = await apiClient.get<LlmConfig>(`/llm-configs/${configId}`);
  return res.data;
}

export async function updateLlmConfig(
  configId: string,
  input: Partial<CreateLlmConfigInput>
): Promise<LlmConfig> {
  const res = await apiClient.put<LlmConfig>(`/llm-configs/${configId}`, input);
  return res.data;
}

export async function deleteLlmConfig(configId: string): Promise<void> {
  await apiClient.delete(`/llm-configs/${configId}`);
}

/** 查询各 provider 可用模型清单 */
export async function fetchProviderModels(): Promise<Record<string, string[]>> {
  const res = await apiClient.get<Record<string, string[]>>('/llm-configs/providers/models');
  return res.data;
}

/**
 * 更新 Agent 的模型绑定 / 预算（复用主平台 PUT /agents/{id}，写入即同步 active profile）。
 * 返回 AgentResponse（含 budget 回显）。
 */
export async function updateAgent(
  agentId: string,
  data: { llm_config_id?: string | null; budget?: Record<string, unknown> | null }
): Promise<Record<string, unknown>> {
  const res = await apiClient.put<Record<string, unknown>>(`/agents/${agentId}`, data);
  return res.data;
}

/** 查询 Agent 详情（主平台 GET /agents/{id}）：llm_config_id 绑定与 budget 预算回显 */
export interface AgentDetail {
  id: string;
  name: string;
  llm_config_id?: string | null;
  budget?: Record<string, unknown> | null;
  [key: string]: unknown;
}

export async function getAgent(agentId: string): Promise<AgentDetail> {
  const res = await apiClient.get<AgentDetail>(`/agents/${agentId}`);
  return res.data;
}
